module.exports = __webpack_public_path__ + "static/media/ChatGPTIcon.6b75a343.svg";